export interface Feature {
  name: string;
  value: string;
  winningVariantName: string;
}
